<form [formGroup]="form" novalidate>
    <ion-text color="primary" class="ion-text-center">
        <h1>Verify</h1>
    </ion-text>

    <ion-list class="ion-padding">
        <!-- Phone -->
        <ion-row>
            <ion-col size="4">
                <ion-item>
                    <ion-input labelPlacement="floating" type="tel" formControlName="country_code" name="Country code" placeholder="+1">
                        <div slot="label">Country <ion-text color="danger">*</ion-text></div>
                    </ion-input>
                </ion-item>
            </ion-col>
            <ion-col size="8">
                <ion-item>
                    <ion-input labelPlacement="floating" type="tel" formControlName="phone" name="Phone">
                        <div slot="label">Area code + Phone <ion-text color="danger">*</ion-text></div>
                    </ion-input>
                </ion-item>
            </ion-col>

        </ion-row>

        <ion-item>
            <ion-input labelPlacement="floating" formControlName="code" name="Code" type="number">
                <div slot="label">Code <ion-text color="danger">*</ion-text></div>
            </ion-input>
        </ion-item>

        <div style="height: 10px"></div>
        <ion-button type="submit" expand="block" color="primary" (click)="verify()" [disabled]="isLoading" name="Verify">
            <span *ngIf="!isLoading">Verify</span>
            <ion-spinner *ngIf="isLoading" name="circular"></ion-spinner>
        </ion-button>

    </ion-list>

</form>

<ion-card>
    <ion-card-content>
        If you have trouble verifying your phone number please reach out to us. Make sure to include your name and phone number.
        <ion-button routerLink="/feedback"  expand="block" fill="clear">
            Contact us
        </ion-button>
    </ion-card-content>
</ion-card>